import { render, staticRenderFns } from "./veStuRewardType.vue?vue&type=template&id=76a2d710&scoped=true"
import script from "./veStuRewardType.vue?vue&type=script&lang=js"
export * from "./veStuRewardType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a2d710",
  null
  
)

export default component.exports